import { ChatServiceInterface, ChatServiceFactory, ChatServiceType } from './ChatServiceInterface';
import { CrispChatService } from './CrispChatService';
import { createFileLogger } from '../../utils/logger';

const log = createFileLogger('CHAT_FACTORY');

// Placeholder for future chat services
class IntercomChatService implements ChatServiceInterface {
  async initialize(): Promise<void> {
    throw new Error('Intercom service not implemented yet');
  }
  isReady(): boolean { return false; }
  openChat(): void { log.warn('Intercom not implemented'); }
  closeChat(): void { log.warn('Intercom not implemented'); }
  setFloatingButtonVisible(): void { log.warn('Intercom not implemented'); }
  setUser(): void { log.warn('Intercom not implemented'); }
  cleanup(): void { log.warn('Intercom not implemented'); }
}

class ZendeskChatService implements ChatServiceInterface {
  async initialize(): Promise<void> {
    throw new Error('Zendesk service not implemented yet');
  }
  isReady(): boolean { return false; }
  openChat(): void { log.warn('Zendesk not implemented'); }
  closeChat(): void { log.warn('Zendesk not implemented'); }
  setFloatingButtonVisible(): void { log.warn('Zendesk not implemented'); }
  setUser(): void { log.warn('Zendesk not implemented'); }
  cleanup(): void { log.warn('Zendesk not implemented'); }
}

class CustomChatService implements ChatServiceInterface {
  async initialize(): Promise<void> {
    throw new Error('Custom service not implemented yet');
  }
  isReady(): boolean { return false; }
  openChat(): void { log.warn('Custom chat not implemented'); }
  closeChat(): void { log.warn('Custom chat not implemented'); }
  setFloatingButtonVisible(): void { log.warn('Custom chat not implemented'); }
  setUser(): void { log.warn('Custom chat not implemented'); }
  cleanup(): void { log.warn('Custom chat not implemented'); }
}

export class ChatServiceFactoryImpl implements ChatServiceFactory {
  createService(type: ChatServiceType): ChatServiceInterface {
    switch (type) {
      case 'crisp':
        return new CrispChatService();
      case 'intercom':
        return new IntercomChatService();
      case 'zendesk':
        return new ZendeskChatService();
      case 'custom':
        return new CustomChatService();
      default:
        throw new Error(`Unsupported chat service type: ${type}`);
    }
  }
}

// Singleton factory instance
export const chatServiceFactory = new ChatServiceFactoryImpl();

